import { render, staticRenderFns } from "./TeachOtoLevel.vue?vue&type=template&id=11942c4e&"
import script from "./TeachOtoLevel.vue?vue&type=script&lang=js&"
export * from "./TeachOtoLevel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports